import type { IAirportItem } from '../components/Common/AirportSelect/Item'

// Map ResolvedDestination from datadirects-platform into existing IAirportItem UI shape
export const mapResolvedDestinationToAirportItem = (destination: any): IAirportItem => {
	const kind: string = destination.kind
	const rawDisplay: string = destination.label || destination.name || ''
	const cityName: string = destination.cityName || destination.name || ''
	const countryName: string = destination.countryName || ''
	const state = destination.regionName || ''
	const countryCode = destination.countryCode
	const stateCode = destination.stateCode
	const cityId = destination.cityPlaceId
	const hotelId = destination.kind === 'hotel' ? destination.placeId : undefined
	const isLandmark = kind === 'landmark'
	const isAirport = kind === 'airport'
	const isSubCity = kind === 'neighborhood' || kind === 'district'

	// Name mapping:
	// - airport: keep full display/airport name
	// - hotel: use hotel/display name
	// - landmark/neighborhood/district: use the place name (not parent city)
	// - city/region/...: use plain city name to avoid "Paris, France, France"
	let name: string
	if (isAirport) {
		name = destination.name || rawDisplay || cityName
	} else if (kind === 'hotel') {
		name = destination.hotelName || destination.name || rawDisplay || cityName
	} else if (isLandmark || isSubCity) {
		name = destination.name || rawDisplay || cityName
	} else {
		name = cityName || rawDisplay
	}

	const city = cityName
	const country = countryName
	const iata = isAirport ? destination.iataCode || '' : ''

	let type = 'city'
	let kayakType = 'city'
	let ptid: string | undefined

	if (isAirport) {
		type = 'airport'
		kayakType = 'ap'
	} else if (kind === 'hotel') {
		type = 'hotel'
		kayakType = 'hotel'
		if (hotelId) {
			ptid = `h${hotelId}`
		}
	} else if (isLandmark || isSubCity) {
		type = isLandmark ? 'landmark' : kind
		kayakType = isLandmark ? 'landmark' : 'city'
		if (destination.placeId) {
			ptid = `p${destination.placeId}`
		}
	} else {
		type = 'city'
		kayakType = 'city'
		if (cityId) {
			ptid = `c${cityId}`
		}
	}

	const documentId = destination.destcode || destination.placeId || destination.entityId || name

	return {
		name,
		country,
		city,
		state,
		iata,
		type,
		documentId,
		placeId: destination.placeId ? String(destination.placeId) : undefined,
		cityID: cityId ? String(cityId) : '',
		airportID: '',
		allAirports: false,
		kayakType,
		ptid,
		countryCode,
		stateCode,
		resolvedDestination: destination,
		destcode: destination.destcode,
	}
}
